// The line under each company in the switcher: the owner's email. It used to
// print `emaildomain`, which no form ever let anyone fill in — the Add
// Company forms quietly sent the placeholder 'deneme', so every company
// created from the dashboard showed "deneme" under its name (owner report,
// 2026-09-23). No email, no line: a filler word says nothing.
export const companySubtitle = (company) => {
  const email = typeof company?.owneremail === 'string' ? company.owneremail.trim() : '';
  return email || null;
};
